import type { HistoryContributionStatus } from '@gwc/shared';
import { Badge } from './ui';

const TONE: Record<HistoryContributionStatus, 'neutral' | 'info' | 'warning' | 'success' | 'danger'> = {
  draft: 'neutral',
  submitted: 'info',
  needs_info: 'warning',
  merged: 'success',
  declined: 'danger',
};
export const STATUS_LABEL: Record<HistoryContributionStatus, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  needs_info: 'Needs info',
  merged: 'Merged',
  declined: 'Declined',
};

export function ContributionStatusBadge({ status }: { status: HistoryContributionStatus }) {
  return <Badge tone={TONE[status] ?? 'neutral'}>{STATUS_LABEL[status] ?? status}</Badge>;
}
